import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FormGroup } from '@angular/forms';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: null,
})
export class AppGenServiceService {
  appGenData: any = {};
  constructor(private http: HttpClient) {}

  setDropDown(comboId, configuration?): Observable<any> {
    let body = {
      LOC_ID: '1',
      LANG_ID: '1',
      ComboId: comboId + '',
    };
    if (configuration) {
      body = Object.assign(body, configuration);
    }

    return this.http.post('/worklist/get-combo-list', body);
  }
  // refId?
  getFormData(
    eventId?,
    formId?,
    tid?,
    fileId?,
    additionalVOlist?,
    preview?
  ): Observable<any> {
    // let data = {
    //   eventId: '23',
    //   elementId: '20000',
    //   idVal: '2',
    // };
    // let data = {
    //   eventId: '23',
    //   formId: '16',
    //   appRefId: '141',
    //   roleId: '123337392',
    // };
    // refId: refId,
    let data = {
      eventId: eventId ? eventId : '1',
      formId: formId,
      appRefId: tid,
      //roleId: '123337392',
      fileId: fileId,
      additionalAttributeVO: additionalVOlist,
      preview,
    };
    return this.http.post('/appgen/renderingComponent', data);
  }

  getSubmittedData(data): Observable<any> {
    //     let data = {
    //       "eventId":"23",
    //       "elementId":"20000",
    //       "idVal":"2"
    // }
    return this.http.post('/appgen/renderingComponent', data);
  }

  requestEventID(data: any) {
    return this.http.post('/appgen/get-event-id', data);
  }

  getComboData() {
    // http://localhost:8023/digigov/appgen/getComboData/140000050
    return this.http.get('/appgen/getComboData/140000050');
  }

  saveData(data: any) {
    return this.http.post('/appgen/saveComponent', data);
  }

  appGenQCACheck(data: any) {
    return this.http.post('/qca/check-qca-status', data);
  }
  requestNotification(data: any) {
    return this.http.post('/appgen/send-notification', data);
  }
  executeRule(data: any) {
    return this.http.post('/rule-engine/execute-rule', data);
  }
  saveChecklistDetails(json) {
    return this.http.post('/common-app/save-checklist-dtls', json);
  }
  setAppGenData(fieldId, data, colData?) {
    if (fieldId == null) {
      this.appGenData = { ...this.appGenData, ...data };
    } else {
      if (colData) {
        data.forEach((ele) => {
          for (const x in ele) {
            if (
              x != 'uniqueKey' &&
              x != '_dynamicRowIndex' &&
              x != 'operation' &&
              x != 'actions'
            ) {
              colData.forEach((element) => {
                if (element.columnId == x) {
                  ele[element.fieldId] = ele[x];
                }
              });
            }
          }
        });
      }

      this.appGenData[fieldId] = data;
    }

  
  }

  getAppGenData(formId, transactionId?) {
    if (transactionId) this.appGenData.transactionId = transactionId;
    this.appGenData.formId = formId;
    return this.appGenData;
  }

  getComboIds(comboId: any,configuration?) {
    let body = {
      LOC_ID: '1',
      LANG_ID: '1',
      ComboId: comboId,
    };
    if (configuration) {
      body = Object.assign(body, configuration);
    }
    return this.http.post('/worklist/get-combo-list', body).pipe(
      map((response: any) => response?.data),
      catchError((error) => throwError(error))
    );
  }
}
